require('./passView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { Component } = require('react');
const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { withRouter } = require('react-router-dom');

// @commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { formatText, getFinalTitle, FormattedText } = require('core/i18n').i18n;
const { toCamelCase } = require('utilities/stringHelper');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const InactiveAccountsError = require('components/commons/inactiveAccountsError/inactiveAccountsError');

// @components
const PassStep1 = require('components/transfersSteps/passSteps/passStep1/passStep1');
const PassStep2 = require('components/transfersSteps/passSteps/passStep2/passStep2');
const PassSuccessStep = require('components/transfersSteps/passSteps/passSuccessStep/passSuccessStep');
const InsufficientAccounts = require('components/insufficientAccounts/insufficientAccounts');
const { LoadingSection } = require('commonsComponents/loadingSection');
const WizardError = require('components/commons/wizardError/wizardError');
const TransfersMoreOptionsButton = require('components/transfers/transfersMoreOptionsButton/transfersMoreOptionsButton');
const TransfersOptionsButton = require('components/transfers/transfersOptionsButton/transfersOptionsButton');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { EmptyState } = require('commonsComponents/emptyState');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const OKModal = require('components/commons/OKModal/OKModal');
import NoNewAccountError from './components/noNewAccountError';

// @actions
const passActions = require('actions/passActions');

//@ utilities
import { areSameReferenceStandard } from 'utilities/accountTypeHelper';
const { getNumOfActiveAccounts } = require('utilities/currentAccountsHelper');
const { recordLinkV2 } = require('utilities/tagging');

// @constants
const { EURO_TEXT, GRAPHIC_TUTOR_TYPE_4, FIRST_STEP, MODAL_MIN_LIMIT_EVENT, MODAL_MAX_LIMIT_EVENT, MODAL_MAX_LIMIT_ERROR } = require('constants/index');
const { WEB_INACTIVE_ACCOUNT_ENABLED, TRANSFERS_POPUP_BETWEEN_3K_25K } = require('constants/flagBasedFeatures');

const KNOWN_API_ERRORS = {
    INACTIVE_ACCOUNT: 'OPERACION NO EJECUTADA, EXISTEN AVISOS EN LA CUENTA O PROPIOS DEL APUNTE',
    BLOCKED_ACCOUNT: 'OPERACION NO PERMITIDA.'

};

class PassView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            internalTransferDepositModalStatus: false,
            redirectBtnClicked: false
        }
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.buildError = this.buildError.bind(this);
        this.handleValidateStep = this.handleValidateStep.bind(this);
        this.handleToggleShowModal = this.handleToggleShowModal.bind(this);
        this.navigateToNextstep = this.navigateToNextstep.bind(this);
        this.doTagging = this.doTagging.bind(this);
        this.redirectToDeposit = this.redirectToDeposit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        const { 
            location: { state: redirectionState }, 
            passActions: { setToAccount, setPredefinedToAccount, setNewAccountNotFoundError }, 
            immAccountsState 
        } = this.props;
        if (redirectionState && redirectionState.accountCodbban) {
            const newAccount = immAccountsState.get('byId').find(account => account.getIn(['ibanComplex', 'codbban']) === redirectionState.accountCodbban);
            if (newAccount) {
                const newAccountId = newAccount.get('accountId');
                const currency = immAccountsState.getIn(['byId', newAccountId, 'balance', 'currency']);
                setToAccount(newAccountId, currency);
                setPredefinedToAccount(true);
            } else {
                setNewAccountNotFoundError(true);
            }
        }
        const redirectionAccountState = immAccountsState.get('redirectionAccountState')?.toJS();

        if (redirectionAccountState) {
            const { type, subtype, standard } = redirectionAccountState;
            const accounts = immAccountsState.get('byId');

            const accountsWithSameType = accounts.filter(account => {
                return areSameReferenceStandard(
                { type, subtype, standard }, 
                { 
                    type: account.get('newProduct'), 
                    subtype: account.get('accountType'), 
                    standard: account.get('standard') 
                }
            )});
            if (accountsWithSameType.size === 1) {
                const account = accountsWithSameType.first();
                setToAccount(account.get('accountId'), account.getIn(['balances', 'availableBalance', 'currency']));
                setPredefinedToAccount(true);
            }
        } 
    }

    componentWillUnmount() {
        this.props.passActions.reset();
        window.history.replaceState(null, '');
        this.props.passActions.resetAccountRedirectionState();
    }

    handleCancel() {
        this.props.history.push('/myprofile/transfers');
    }
    handleValidateStep() {
        const {
            history, immPassState, passActions, immFlagBasedFeatures, immVariables
        } = this.props
        const visibleStep = immPassState.get('visibleStep');
        const immFirstStep = immPassState.getIn(['steps', FIRST_STEP]);
        const amount = immFirstStep.get("amount")
        const depositLimits = immVariables && immVariables.get('deposit');
        const maxLimit = +depositLimits.get('maxLimit');
        const minLimit = +depositLimits.get('minLimit');
        passActions.validateStep(visibleStep, history, false);
        (amount <= maxLimit) && (amount >= minLimit) && immFlagBasedFeatures.get(TRANSFERS_POPUP_BETWEEN_3K_25K) && this.handleToggleShowModal('open');
    }
    doTagging(eventType) {
        let etiquetaEvento = '';
        switch (eventType) {
            case 'open':
                etiquetaEvento = "vista";
                break;
            case 'close':
                etiquetaEvento = "close";
                break;
            case 'continue':
                etiquetaEvento = "no/continuar transferencia";
                break;
            case 'redirect':
            case 'redirectFromMax':
                etiquetaEvento = "contratar";
                break;
            default:
                break;
        }
        const analyticsData = {
            categoriaEvento: MODAL_MAX_LIMIT_EVENT,
            accionEvento: eventType === 'redirectFromMax' ? MODAL_MAX_LIMIT_ERROR : MODAL_MIN_LIMIT_EVENT,
            etiquetaEvento: etiquetaEvento
        }
        recordLinkV2(analyticsData);
    }

    handleToggleShowModal(eventType) {
        this.setState(previousState => ({
            internalTransferDepositModalStatus: !previousState.internalTransferDepositModalStatus
        }), this.doTagging(eventType));
    }
    navigateToNextstep() {
        const { history, immPassState, passActions } = this.props
        const visibleStep = immPassState.get('visibleStep');
        passActions.validateStep(visibleStep, history);
        this.handleToggleShowModal('continue')
    }
    redirectToDeposit = (source) => {
        this.setState({
            redirectBtnClicked: !this.state.redirectBtnClicked
        },
            () => {
                source ? this.doTagging('redirect') : this.doTagging('redirectFromMax')
                this.props.history.push('/myprofile/purchase/deposit-eighteen-months')
            });
    }

    checkDifferentStandardCriteria(immAccount) {
        const { immAccountsState } = this.props;
        const redirectionAccountState = immAccountsState.get('redirectionAccountState')?.toJS();

        if (redirectionAccountState && !!redirectionAccountState.type) {
            const { type, subtype, standard } = redirectionAccountState;
            return !areSameReferenceStandard({ type, subtype, standard }, {
                type: immAccount.get('newProduct'),
                subtype: immAccount.get('accountType'),
                standard: immAccount.get('standard')
            });
        } else {
            return false;
        }
    }

    handleDisableAccountOption(immAccount) {
        const DISABLE_CRITERIAS = [
            this.checkDifferentStandardCriteria(immAccount),
        ];
        return DISABLE_CRITERIAS.some(criteria => criteria);
    }

    buildWizard(originAccount, destinationAccount, immOriginAccounts, originAccountsIndexes) {
        const {
            immAccountsState,
            immFlagBasedFeatures,
            immPassState,
            immSignaturePattern,
            match: { params: { accountId } },
            passActions,
            immVariables
        } = this.props;
        const firstStep = immPassState.getIn(['steps', FIRST_STEP]);
        const accountsList = immAccountsState.get('byOrder');
        const accountsMap = immAccountsState.get('byId');
        const immSteps = immPassState.get('steps');
        const immFinalButton = immSteps.get(0).get('isToday')
            ? 'mytransfers-pass'
            : 'mytransfers-futurePass';
        const originalAccountIndex = accountId;
        const stepsAmount = immSteps.size;
        const amount = firstStep.get("amount")
        const depositLimits = immVariables && immVariables.get('deposit');
        const maxLimit = +depositLimits.get('maxLimit');
        const minLimit = +depositLimits.get('minLimit');
        const actions = {
            setWillCancel: passActions.setWillCancel,
            setVisibleStep: passActions.setVisibleStep,
            finish: passActions.postTransfer,
            validateStep: (amount <= maxLimit) && (amount >= minLimit) && immFlagBasedFeatures.get(TRANSFERS_POPUP_BETWEEN_3K_25K) ? this.handleValidateStep : passActions.validateStep,
            cancel: this.handleCancel
        };
        let visibleStep = immPassState.get('visibleStep');
        let initialAccountId =
            originalAccountIndex >= 0 ? accountsList.get(originalAccountIndex) : '';
        let accountsIndexes = accountsList.toJS();
        let isFetching = immPassState.get('isFetching');

        ///originAccountsIndexes are listed by 'byId' order. Below we sort the indexes by 'byOrder' order.
        originAccountsIndexes = accountsIndexes.filter(i => originAccountsIndexes.indexOf(i) !== -1);

        return (
            <Wizard
                wizardClass="my-pass__wizard"
                actions={actions}
                immSteps={immSteps}
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
                isFetching={isFetching}
                fullWidth={true}
                showPreLeaveModal={this.state.redirectBtnClicked ? false : true}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    isLoading={immPassState.get('isValidating')}
                >
                    <PassStep1
                        immAccounts={accountsMap}
                        disableDestinationAccountOption={(immAccount) => this.handleDisableAccountOption(immAccount)}
                        accountsIndexes={accountsIndexes}
                        initialAccountId={initialAccountId}
                        immPassState={immPassState}
                        isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
                        actions={passActions}
                        immOriginAccounts={immOriginAccounts}
                        originAccountsIndexes={originAccountsIndexes}
                        depositLimits={depositLimits}
                        immFlagBasedFeatures={immFlagBasedFeatures}
                        redirectToDeposit={this.redirectToDeposit}
                    />
                </WizardStep>
                <WizardStep
                    addLoadingBehaviour={true}
                    position="last"
                    cancelButton={true}
                    immFinalButton={immFinalButton}
                    isLoading={immSignaturePattern.get('isFetchingConfig')}>
                    <PassStep2
                        originAccount={originAccount}
                        destinationAccount={destinationAccount}
                        immPassState={immPassState}
                        actions={passActions}
                        signaturePatternRequired={
                            immSignaturePattern.get('requiredSMS') ||
                            immSignaturePattern.get('requiredDigits')
                        }
                    />
                </WizardStep>
            </Wizard>
        );
    }

    buildSuccessful(originAccount, destinationAccount) {
        const { immPassState } = this.props;
        return (
            <div className="col-xs-12 col-md-offset-2 col-md-8 pass-view__left-first-box-full">
                <PassSuccessStep
                    immPassState={immPassState}
                    originAccount={originAccount}
                    destinationAccount={destinationAccount}
                />
            </div>
        );
    }

    buildError() {
        const { immPassState } = this.props;
        const errorReceived = immPassState.get('errorReceived');
        let errorSubMessage;

        if (errorReceived.get('description') === KNOWN_API_ERRORS.INACTIVE_ACCOUNT || errorReceived.get('description') === KNOWN_API_ERRORS.BLOCKED_ACCOUNT) {
            errorSubMessage = <FormattedText value="passErrorStep-inactiveAccount" />;
        }

        return (
            <div className="col-xs-12 col-md-offset-2 col-md-8 pass-view__left-first-box-full">
                <WizardError errorMessage={formatText('passErrorStep-title')} errorSubMessage={errorSubMessage} />
            </div>
        );
    }

    buildEmptyOriginAccounts() {
        const title = formatText('mytransfers-noFromAccountsTitle');
        const primaryText = formatText('mytransfers-noFromAccountsMessage');
        const linkText = formatText('mytransfers-errorBackToTransfersLink');
        const backToTransfersLink = '/myprofile/transfers';
        return (
            <div className="col-xs-12 col-md-offset-2 col-md-8 pass-view__left-first-box-full">
                <OKSectionBox>
                    <EmptyState
                        title={title}
                        primaryText={primaryText}
                        linkText={linkText}
                        linkURL={backToTransfersLink}
                        iconType="noitems-banking" />
                </OKSectionBox>
            </div>
        );
    }

    buildInactiveAccountsError() {
        return (<InactiveAccountsError
            navigateToBackButtonText={'transfers'}
            navigateToBackButtonURL={'transfers'}
        />);
    }

    render() {
        const { immPassState, immAccountsState, immVariables, immFlagBasedFeatures, history } = this.props;
        const accountsList = immAccountsState.get('byOrder');
        const accountsMap = immAccountsState.get('byId');
        const immSteps = immPassState.get('steps');
        const fromAccountId = immSteps.get(0).get('fromAccount');
        const toAccountId = immSteps.get(0).get('toAccount');
        const originAccount = fromAccountId ? accountsMap.get(fromAccountId) : undefined;
        const destinationAccount = toAccountId ? accountsMap.get(toAccountId) : undefined;
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-transfers'),
                url: '/myprofile/transfers'
            },
            {
                text: toCamelCase(formatText('mytransfers-newPass'))
            }
        ];
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_4}
                title={formatText('tutorials-transfersAccountsTitle')}
            />
        );
        let passContent = <div className="pass-view__content" />;
        let moreOptionsButton;
        let optionsButton;

        // (andres): The origin account HAS to be an euro account, so we filter out the other
        // currencies since the service won't allow it
        let originAccountsIndexes = [];
        const immOriginAccounts = accountsMap.filter(immAccount => {
            if (
                immAccount.getIn(['balances', 'availableBalance', 'currency']) === EURO_TEXT &&
                immAccount.getIn(['balances', 'availableBalance', 'amount']) > 0
            ) {
                originAccountsIndexes.push(immAccount.get('accountId'));
                return true;
            }
        });
        if (immPassState.get('validationError')) {
            passContent = this.buildError();
        } else if (immAccountsState.get('isFetching')) {
            passContent = <LoadingSection />;
        } else if (immPassState.get('newAccountNotFoundError')) {
            passContent = <NoNewAccountError history={history} />
        } else if (accountsList.size === 1) {
            passContent = <InsufficientAccounts />;
        } else if (immPassState.get('submitSuccessful')) {
            passContent = this.buildSuccessful(originAccount, destinationAccount);
        } else if (immOriginAccounts.size === 0 && getNumOfActiveAccounts(accountsList, accountsMap) < 2) {
            passContent = this.buildInactiveAccountsError();
        } else if (immOriginAccounts.size === 0) {
            passContent = this.buildEmptyOriginAccounts();
        } else if (getNumOfActiveAccounts(accountsList, accountsMap) < 2) {
            passContent = this.buildInactiveAccountsError();
        } else if (accountsList.size > 1) {
            passContent = this.buildWizard(originAccount, destinationAccount, immOriginAccounts, originAccountsIndexes);
            const immAccount = immAccountsState.get('byId').get(immAccountsState.get('byOrder').get(0));

            moreOptionsButton = (<TransfersMoreOptionsButton hiddenOnMobile={true} immAccount={immAccount} />);
            optionsButton = (<TransfersOptionsButton hiddenOnMobile={true} immAccount={immAccount} />);
        }
        let depositModal;
        if (this.state.internalTransferDepositModalStatus) {

            const transferModalMinLimitTitle = formatText("transferSummary-transferModalMinLimitTitle");
            const transferModalMinLimitContent = formatText("transferSummary-transferModalMinLimitContent")
            const transferModalMinLimitPrimaryButtonText = formatText('transferSummary-transferModalMinLimitPrimaryButtonText')
            const transferModalMinLimitSecondaryButtonText = formatText('transferSummary-transferModalMinLimitSecondaryButtonText')
            let modalContent2 = (<p>{transferModalMinLimitContent}</p>);
            const immFirstStep = immPassState.getIn(['steps', FIRST_STEP]);
            const isValidForm = immFirstStep.get("valid", true);
            const amount = immFirstStep.get("amount");
            const depositLimits = immVariables && immVariables.get('deposit');
            const maxLimit = +depositLimits.get('maxLimit');
            const minLimit = +depositLimits.get('minLimit');
            let limitCondition2 = isValidForm && ((amount <= maxLimit) && (amount >= minLimit)) && immFlagBasedFeatures.get(TRANSFERS_POPUP_BETWEEN_3K_25K);
            depositModal = limitCondition2 &&
                <OKModal
                    content={modalContent2}
                    isOpen={this.state.internalTransferDepositModalStatus}
                    onCloseCallback={() => this.handleToggleShowModal('close')}
                    onPrimaryButtonClick={this.navigateToNextstep}
                    primaryButtonText={transferModalMinLimitPrimaryButtonText}
                    title={transferModalMinLimitTitle}
                    footerType="action"
                    onSecondaryButtonClick={this.redirectToDeposit}
                    secondaryButtonText={transferModalMinLimitSecondaryButtonText}
                />
        }

        return (
            <article className="pass-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="transfers" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                tutorial={tutorial}
                                finalTitle={getFinalTitle('mytransfers-newPass')}
                            >
                                {moreOptionsButton}
                                {optionsButton}
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid grid-view--content-position-negative">
                        {passContent}
                        {depositModal}
                    </div>
                </div>
            </article>
        );
    }
}

PassView.propTypes = {
    passActions: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    immAccountsState: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immPassState: PropTypes.object.isRequired,
    immSignaturePattern: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    immVariables: PropTypes.object
};

module.exports.constructor = PassView;
module.exports.PassView = connect(
    state => ({
        immAccountsState: state.accounts,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immPassState: state.pass,
        immSignaturePattern: state.signaturePattern,
        immVariables: state.globalVariables.getIn(['variables', 'parameters']),
    }),
    dispatch => ({
        passActions: bindActionCreators(passActions, dispatch)
    })
)(withRouter(PassView));
